/*** IMPORTS FROM imports-loader ***/
var define = false;

module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/.npminstall/core-js/2.4.1/core-js/library/modules/_fails.js
// module id = 38
// module chunks = 0